"use client";

import Link from "next/link";

const PrivacyPage = () => {
  return (
    <main className="container mx-auto px-4 py-12">
      <h1 className="text-center text-4xl font-bold text-gray-900 dark:text-white">
        Politique de Confidentialité
      </h1>
      <p className="mt-2 text-center text-gray-600 dark:text-gray-300">
        Dernière mise à jour : 3 février 2025
      </p>

      <section className="mx-auto mt-10 max-w-3xl rounded-lg bg-white p-6 shadow dark:bg-gray-800">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
          1. Introduction
        </h2>
        <p className="mt-4 text-gray-700 dark:text-gray-300">
          Chez <span className="font-semibold">Les Concernés</span>, nous
          attachons une grande importance à la protection de votre vie privée.
          Cette politique explique quelles informations nous collectons, comment
          nous les utilisons et quels sont vos droits.
        </p>
      </section>

      <section className="mx-auto mt-8 max-w-3xl rounded-lg bg-white p-6 shadow dark:bg-gray-800">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
          2. Données collectées
        </h2>
        <p className="mt-4 text-gray-700 dark:text-gray-300">
          Nous collectons différentes données personnelles lorsque vous utilisez
          notre site :
        </p>
        <ul className="mt-2 list-disc pl-5 text-gray-700 dark:text-gray-300">
          <li>
            Votre nom, email et informations de contact lorsque vous nous
            contactez.
          </li>
          <li>
            Les informations fournies lors de votre adhésion à l'association.
          </li>
          <li>
            Les données de navigation, y compris les cookies et technologies
            similaires.
          </li>
        </ul>
      </section>

      <section className="mx-auto mt-8 max-w-3xl rounded-lg bg-white p-6 shadow dark:bg-gray-800">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
          3. Utilisation des données
        </h2>
        <p className="mt-4 text-gray-700 dark:text-gray-300">
          Les informations collectées sont utilisées pour :
        </p>
        <ul className="mt-2 list-disc pl-5 text-gray-700 dark:text-gray-300">
          <li>
            Vous fournir des services et améliorer votre expérience utilisateur.
          </li>
          <li>
            Envoyer des newsletters et des informations sur nos actions (avec
            votre consentement).
          </li>
          <li>Analyser le trafic et les performances de notre site.</li>
        </ul>
      </section>

      <section className="mx-auto mt-8 max-w-3xl rounded-lg bg-white p-6 shadow dark:bg-gray-800">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
          4. Cookies et technologies similaires
        </h2>
        <p className="mt-4 text-gray-700 dark:text-gray-300">
          Notre site utilise des cookies pour améliorer l’expérience utilisateur
          et analyser le trafic. Vous pouvez gérer vos préférences via les
          paramètres de votre navigateur.
        </p>
      </section>

      <section className="mx-auto mt-8 max-w-3xl rounded-lg bg-white p-6 shadow dark:bg-gray-800">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
          5. Droits des utilisateurs
        </h2>
        <p className="mt-4 text-gray-700 dark:text-gray-300">
          Conformément aux réglementations en vigueur (RGPD, CNIL), vous
          disposez des droits suivants :
        </p>
        <ul className="mt-2 list-disc pl-5 text-gray-700 dark:text-gray-300">
          <li>Accéder à vos données personnelles.</li>
          <li>Demander leur rectification ou suppression.</li>
          <li>Retirer votre consentement à tout moment.</li>
          <li>
            Porter plainte auprès de la CNIL si vous estimez que vos droits ne
            sont pas respectés.
          </li>
        </ul>
      </section>

      <section className="mx-auto mt-8 max-w-3xl rounded-lg bg-white p-6 shadow dark:bg-gray-800">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
          6. Modifications de cette politique
        </h2>
        <p className="mt-4 text-gray-700 dark:text-gray-300">
          Nous pouvons mettre à jour cette politique de confidentialité à tout
          moment. La date de la dernière mise à jour sera toujours indiquée en
          haut de la page.
        </p>
      </section>

      <section className="mx-auto mt-8 max-w-3xl rounded-lg bg-white p-6 shadow dark:bg-gray-800">
        <h2 className="text-2xl font-semibold text-gray-900 dark:text-white">
          7. Contact
        </h2>
        <p className="mt-4 text-gray-700 dark:text-gray-300">
          Pour toute question concernant cette politique, vous pouvez nous
          contacter à :
        </p>
        <p className="mt-2 font-semibold text-gray-900 dark:text-white">
          📧{" "}
          <Link
            href="mailto:contact@lesconcernes.com"
            className="text-blue-500 hover:underline"
          >
            contact@lesconcernes.com
          </Link>
        </p>
      </section>
    </main>
  );
};

export default PrivacyPage;
